import { BorderGridContainer, Button, GridBox, H2, SpacerWrapper, TabGroup, TypeWrapper } from '@ahmdigital/ui';
import { compact, find, get, head, isEmpty, kebabCase, map, reject, size } from 'lodash/fp';
import React, { useState } from 'react';

import { CompareCoverGroup, InsuranceGroup } from '../../types';
import { FootnoteType } from '../../../../types/footnote';
import { SellingPointGroup } from '../../../../types/explained';
import CompareCover from './compare-cover';
import InclusionsPanel from './panel';
import pageStyles from '../../styles.module.sass';
import styles from './styles.module.sass';

export type InclusionsGroup = CompareCoverGroup | InsuranceGroup | SellingPointGroup;

type InclusionsProps = {
  cta?: {
    name: string;
    url: string;
  };
  footnote?: FootnoteType;
  groups?: InclusionsGroup[];
  title: string;
};

const Inclusions = ({ cta, footnote, groups, title }: InclusionsProps) => {
  // @ts-expect-error - Automatic, Please fix when editing this file
  const defaultGroup = size(groups) > 2 ? groups[1] : head(groups);
  // @ts-expect-error - Automatic, Please fix when editing this file
  const [value, setValue] = useState(kebabCase(get('tabTitle', defaultGroup)));

  if (isEmpty(groups)) {
    return null;
  }

  const productPanels = map(
    (group: SellingPointGroup) => ({
      panel: <InclusionsPanel key={group.tabTitle} {...group} footnote={footnote} isPortableTextDescription />,
      text: group.tabTitle,
      value: kebabCase(group.tabTitle),
    }),
    reject({ id: 'compare' }, groups),
  );

  const compare = find({ id: 'compare' }, groups) as CompareCoverGroup;
  const comparisonPanel = compare && {
    panel: <CompareCover {...compare} />,
    text: compare.tabTitle,
    value: kebabCase(compare.tabTitle),
  };

  const tabGroupOptions = compact([...productPanels, comparisonPanel]);

  return (
    <BorderGridContainer>
      <GridBox padding="1rem">
        <div className={pageStyles.horizontalSpacingWrapper}>
          <SpacerWrapper variant={['paddingTopSpacer3', 'paddingBottomSpacer9']}>
            <TypeWrapper variant="center">
              <H2 variant="marginBottomSpacer4">{title}</H2>
            </TypeWrapper>
            <TabGroup
              tabListVariant={styles.tabList}
              input={{
                onChange: setValue,
                value,
              }}
              options={tabGroupOptions}
            />
          </SpacerWrapper>
          {cta && (
            <SpacerWrapper variant={[styles.cta, 'paddingBottomSpacer8']}>
              <Button to={cta.url}>{cta.name}</Button>
            </SpacerWrapper>
          )}
        </div>
      </GridBox>
    </BorderGridContainer>
  );
};

export default Inclusions;
